import React, { useState } from "react";
import DataTable from "../../components/Table";
import { convertDateInFormat } from "../../utils/utils";

const ReconciliationReportTable = ({
  reconciliationReportData,
  selectedRange,
}) => {
  const prepareReportTableData = (data) => {
    return data.map((item) => ({
      proposalNumber: item.proposalNumber,
      policyNumber: item.policyNumber || "-",
      policyOwnerName: item.policyOwnerName,
      mcustomerAcknowledgementNo: item.mcustomerAcknowledgementNo,
      instrumentNumber: item.instrumentNumber || "-",
      bankName: item.bankName,
      instrumentAcknowledgementDate: item.instrumentAcknowledgementDate,
      instrumentAmount: item.instrumentAmount,
      modeOfPayment: item.instrumentType,
      productName: item.productName,
      agentSPCode: item.agentSPCode,
      channelName: item.channelName,
      serviceType: item.serviceType,
      region: item.region || "-",
      receiptDateTime: item.receiptDateTime,
      receiptStatus:
        item.receiptStatus === "ACKNOWLEDGED"
          ? "Acknowledged"
          : item.receiptStatus === "CANCELED"
          ? "Cancelled"
          : "Yet to Acknowledge",
      policyStatus: item.policyStatus || "-",
      bopsUserAcknowledged: item.bopsUserAcknowledged,
      cancellationReason: item.cancellationReason,
      instrumentTransactionDate: item.instrumentTransactionDate,
      instrumentAcknowledgementDate: item.instrumentAcknowledgementDate,
      agentSPName: item.agentSPName,
    }));
  };

  const calculateSummary = (data) => {
    const summary = {
      CHEQUE: {
        agency: 0,
        cab: 0,
        ddChannel: 0,
      },
      DD: {
        agency: 0,
        cab: 0,
        ddChannel: 0,
      },
    };

    data.forEach((item) => {
      const amt = Number(item.instrumentAmount) || 0;

      const type = item.instrumentType === "DEMAND_DRAFT" ? "DD" : "CHEQUE";

      if (item.channelName === "AGENCY") {
        summary[type].agency += amt;
      } else if (item.channelName === "CAB") {
        summary[type].cab += amt;
      } else if (item.channelName === "DSF") {
        summary[type].ddChannel += amt;
      }
    });

    const chequeTotal =
      summary.CHEQUE.agency + summary.CHEQUE.cab + summary.CHEQUE.ddChannel;

    const ddTotal = summary.DD.agency + summary.DD.cab + summary.DD.ddChannel;

    return [
      {
        label: "Total Cheque Collections",
        agency: summary.CHEQUE.agency,
        cab: summary.CHEQUE.cab,
        dd: summary.CHEQUE.ddChannel,
        total: chequeTotal,
      },
      {
        label: "Total DD Collections",
        agency: summary.DD.agency,
        cab: summary.DD.cab,
        dd: summary.DD.ddChannel,
        total: ddTotal,
      },
      {
        label: "Total",
        agency: summary.CHEQUE.agency + summary.DD.agency,
        cab: summary.CHEQUE.cab + summary.DD.cab,
        dd: summary.CHEQUE.ddChannel + summary.DD.ddChannel,
        total: chequeTotal + ddTotal,
      },
    ];
  };
  return (
    <>
      {
        <div className="reconciliation-report-header">
          <div className="header-row">
            <strong>Branch Name with Address:</strong>
            <div>{reconciliationReportData[0]?.bankName}</div>
          </div>

          <div className="header-row header-title">
            Daily Cheque/DD Reconciliation Register (New Business)
          </div>

          {selectedRange.startDate && (
            <div className="header-row">
              <strong>For the Date Range Selected :</strong>{" "}
              <div>
                {convertDateInFormat(selectedRange.startDate, "DD-MM-YYYY")} to{" "}
                {convertDateInFormat(selectedRange.endDate, "DD-MM-YYYY")}
              </div>
            </div>
          )}
        </div>
      }

      {
        <div className="reconciliation-report-table">
          <DataTable
            cellHeaders={[
              "Proposal No",
              "Policy No",
              "Policy Owner Name",
              "Mcustomer Acknowledgement No",
              "Cheque / DD No",
              "Cheque / DD Bank",
              "Cheque / DD DT",
              "Instrument Amount",
              "Instrument Transaction Date",
              "Instrument Acknowledge Date",
              "Mode of Payment",
              "Product Name",
              "Agent Code",
              "Agent/SP name",
              "Channel",
              "Service Type",
              "Region",
              "Receipt Date & Time",
              "Receipt Status",
              "Reason",
              "Policy Status",
              "User ID who acknowledged",
            ]}
            keys={[
              "proposalNumber",
              "policyNumber",
              "policyOwnerName",
              "mcustomerAcknowledgementNo",
              "instrumentNumber",
              "bankName",
              "instrumentTransactionDate",
              "instrumentAmount",
              "instrumentTransactionDate",
              "instrumentAcknowledgementDate",
              "modeOfPayment",
              "productName",
              "agentSPCode",
              "agentSPName",
              "channelName",
              "serviceType",
              "region",
              "receiptDateTime",
              "receiptStatus",
              "cancellationReason",
              "policyStatus",
              "bopsUserAcknowledged",
            ]}
            data={prepareReportTableData(reconciliationReportData)}
            addSerialNo={true}
            showExcelDownload={false}
            fileName="Daily-Cheque-DD-Reconciliation"
            paginationItems={reconciliationReportData}
            alwaysShown={true}
          />
        </div>
      }

      {
        <div className="reconciliation-summary-table">
          <DataTable
            cellHeaders={[
              "",
              "Agency (Rs)",
              "CAB (Rs)",
              "DD (Rs)",
              "Net (Total)",
            ]}
            keys={["label", "agency", "cab", "dd", "total"]}
            data={calculateSummary(reconciliationReportData)}
            addSerialNo={false}
            alwaysShown={true}
            showExcelDownload={false}
          />
        </div>
      }
    </>
  );
};

export default ReconciliationReportTable;
